export const formFields = [
  {
    section: "Section 1",
    name: "ps3PatientPaySchName",
    label: "Patient Pay Schedule",
    fieldLabel: "PS3 Patient Pay Sch Name",
    type: "text",
    options: { readOnly: true },
    fieldNature: "Add: Read-Only, Change: Read-only, View: Read-only",
    position: [5, 23],
  },
  {
    section: "Section 1",
    name: "ps3PatientPaySchDesc",
    label: "Description",
    fieldLabel: "PS3 Patient Pay Sch Desc",
    type: "text",
    options: { readOnly: true },
    fieldNature: "Add: Read-Only, Change: Read-only, View: Read-only",
    position: [6, 23],
  },
  {
    section: "Section 2",
    name: "ps6Status",
    label: "Status",
    fieldLabel: "Hidden Records Indicator",
    type: "dropdown",
    dropdownCondition: "*Inactive",
    options: { readOnly: true },
    fieldNature: "Add: Non-Display, Change: Non-Display, View: Read-only",
    position: [7, 23],
  },
  {
    section: "Section 2",
    name: "ps6SeqNbr",
    label: "Sts",
    fieldLabel: "Hidden Records Indicator",
    type: "number",
    options: { readOnly: true },
    fieldNature: "Add: Non-Display, Change: Non-Display, View: Non-Display",
    position: [7, 23],
  },
  {
    section: "Section 2",
    name: "ps6FromDate",
    label: "From Date",
    fieldLabel: "PS6 From Date",
    type: "date",
    options: { required: { value: true, message: "Value required" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 23],
  },
  {
    section: "Section 2",
    name: "ps6ThruDate",
    label: "Thru Date",
    fieldLabel: "PS6 Thru Date",
    type: "date",
    options: { required: { value: true, message: "Value required" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 23],
  },
  {
    section: "Client Patient Pay(Header)",
    name: "ps6RebillPatPaySched",
    label: "Schedule",
    fieldLabel: "PS6 Rebill Pat Pay Sched",
    type: "lookup",
    externalProgram: { default: "RCPS3001" },
    params: {
      lookupType: "local",
      viewType: "local",
      disabledDropdown: true,
      fieldMapping: {
        default: [
          {
            source: "ps6RebillPatPaySched",
            target: "ps3PatientPaySchName",
            paramDataKey: "scheduleName",
            legacy: "ps3PatientPaySchName",
          },
          {
            source: "ps6Description",
            target: "ps3PatientPaySchDesc",
            legacy: "ps3PatientPaySchDesc",
          },
        ],
      },
    },
    options: {
      required: { value: true, message: "Value required" },
      maxLength: { value: 10, message: "MAXLENGTH_10" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [10, 23],
  },
  {
    section: "Client Patient Pay(Header)",
    name: "ps6Description",
    label: "Description",
    fieldLabel: "Wrk Description 25",
    type: "text",
    options: { readOnly: true },
    fieldNature: "Add: Read-Only, Change: Read-Only, View: Read-only",
    position: [11, 23],
  },
  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "ADD Date",
    type: "date",
    format: "MM/DD/YY",
    options: { readOnly: true },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 20],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "CHG Date",
    type: "date",
    format: "MM/DD/YY",
    options: { readOnly: true },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 40],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "CHG User Name",
    type: "text",
    options: { readOnly: true },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 57],
  },
];
